module.exports = __webpack_public_path__ + "img/score8.c4e0a4dd.png";